//components
import BusinessDashboardLayout from 'core/layouts/business/businessLayout';
import BusinessLoginPage from 'modules/business/auth/login/pages/login';
import BusinessResetPasswordPage from 'modules/business/auth/reset-password/pages/reset-password';
import BusinessCompanyViewPage from 'modules/business/company/pages/view';
import BusinessMortgageActivitiesPage from 'modules/business/mortgage/pages/activity';
import BusinessMortgageCreatePage from 'modules/business/mortgage/pages/create';
import BusinessMortgageListPage from 'modules/business/mortgage/pages/list';
import BusinessMortgageViewPage from 'modules/business/mortgage/pages/view';
import BusinessProfilePage from 'modules/business/userProfile/pages/profile';
import BusinessUsersManagementCreatePage from 'modules/business/usersManagement/pages/create';
import BusinessUsersManagementListPage from 'modules/business/usersManagement/pages/list';
import BusinessUsersManagementUpdatePage from 'modules/business/usersManagement/pages/update';
import { RouteObject } from 'react-router-dom';

export const BusinessRoutes: RouteObject[] = [
	{ path: 'business', element: <BusinessLoginPage /> },
	{ path: 'business/login', element: <BusinessLoginPage /> },
	{ path: 'business/reset-password', element: <BusinessResetPasswordPage /> },
	{
		path: 'business/dashboard',
		element: <BusinessDashboardLayout />,
		children: [
			{ path: 'mortgages', element: <BusinessMortgageListPage /> },
			{ path: 'mortgages/create', element: <BusinessMortgageCreatePage /> },
			{ path: 'mortgages/activities/:mortgageId', element: <BusinessMortgageActivitiesPage /> },
			{ path: 'mortgages/:mortgageId', element: <BusinessMortgageViewPage /> },
			{ path: 'companies/:companyId', element: <BusinessCompanyViewPage /> },
			{ path: 'profile', element: <BusinessProfilePage /> },
			{ path: 'users-management', element: <BusinessUsersManagementListPage /> },
			{ path: 'users-management/create', element: <BusinessUsersManagementCreatePage /> },
			{ path: 'users-management/update', element: <BusinessUsersManagementUpdatePage /> },
		],
	},
];
